export default __webpack_public_path__ + "static/media/3.8383d764.jpg";